<template>
  <v-dialog v-model="showPopup" persistent max-width="1000" aria-hidden="true">
    <v-card class="pa-4">
      <v-btn
        depressed
        class="close"
        @click="cancel"
      >
        <span class='text-h5'>&times;</span>
      </v-btn>
      <v-card-title class="headline justify-center popup-title">
        {{title}}
      </v-card-title>
      <v-card-text class="d-flex justify-center">
        <PaymentPlans />
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="cancel"
          depressed
          class="cancel-btn small-size"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { MODULE_POPUP } from '@/store/constant/mutation-types'
import PaymentPlans from '@/components/subscription/PaymentPlans'

export default {
  name: 'UpgradeSubscriptionPlanPopup',
  components: {
    PaymentPlans
  },
  data() {
    return {
    }
  },
  watch: {
    showPopup(v) {
      if (!v) {
        this.$store.commit('user/set', { type: 'unpaidError', val: false })
      }
    }
  },
  computed: {
    showPopup() {
      return this.$store.getters[`${MODULE_POPUP}/showUpgradeSubscriptionPlanPopup`]
    },
    title() {
      return this.$store.getters[`${MODULE_POPUP}/getUpgradeSubscriptionPlanPopupTitle`]
    }
  },
  methods: {
    cancel() {
      this.$store.dispatch('closeUpgradeSubscriptionPlanPopup')
    }
  }
}
</script>

<style scoped lang="scss">
.close {
  font-size: 40px;
  background: none !important;
  position: absolute;
  right: 0;
  color: #585858;
  opacity: 0.6;
  min-width: 30px!important;
  height: 30px!important;
  margin: 0;
  padding: 0 !important;
  right: 4px;
  top: 4px;
}
.close:hover {
  background: none !important;
  opacity: 1;
}
.close:not(.v-btn--text):not(.v-btn--outlined):hover:before {
    opacity: 0;
    background: none !important;
}
.theme--light.close:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background: none !important;
}
.close:not(.v-btn--text):not(.v-btn--outlined):focus:before {
    opacity: 0;
    background: none !important;
}
.modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(#000, 0.2);
  .modal-dialog {
    display: flex;
    justify-content: center;
    padding-top: 3vh;
    padding-bottom: 3vh;
    overflow-y: auto;
    height: 100vh;
  }
  .modal-content {
    max-width: 100%;
    box-sizing: border-box;
    &::after {
      content: '';
      height: 3vh;
      display: block;
    }
  }
}
</style>
